var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AfyDataTable, AfyModal, AfyPagination, } from "@affinitysystemsgroup/assurehub-ui";
import { COBRANZA_REJECTED_POLICIES_PAGINATION_LABEL_OF, COBRANZA_REJECTED_POLICIES_SUBTITLE, COBRANZA_REJECTED_POLICY_CODE_LABEL, COBRANZA_REJECTED_POLICY_NAME_LABEL, } from "../../../constants/cobranza.constants";
import { useRejectedPoliciesModal } from "../hook/rejectedPoliciesModal.hook";
import { ModalTitle, PaginationWrapper, PoliciesTableWrapper, PolicyCodeText, PolicyNameText, } from "../style/rejectedPoliciesModal.style";
var MODAL_PROPS = {
    size: "xl",
    centered: true,
};
var TABLE_PROPS = {
    maxHeight: "50vh",
    minHeight: 0,
    hidePagination: true,
};
var PAGINATION_PROPS = {
    showPageSizeSelector: false,
    showRange: true,
    size: "sm",
    labelOf: COBRANZA_REJECTED_POLICIES_PAGINATION_LABEL_OF,
};
var asPolicy = function (row) {
    return row;
};
var COLUMNS = [
    {
        key: "code",
        header: COBRANZA_REJECTED_POLICY_CODE_LABEL,
        render: function (row) { return (_jsx(PolicyCodeText, __assign({ "$muted": !asPolicy(row).hasCode }, { children: asPolicy(row).code }))); },
    },
    {
        key: "name",
        header: COBRANZA_REJECTED_POLICY_NAME_LABEL,
        render: function (row) { return (_jsx(PolicyNameText, __assign({ "$muted": !asPolicy(row).hasName }, { children: asPolicy(row).name }))); },
    },
];
export var RejectedPoliciesModalView = function (props) {
    var modal = useRejectedPoliciesModal(props);
    return (_jsxs(AfyModal, __assign({}, MODAL_PROPS, { opened: props.opened, onClose: props.onClose, title: _jsx(ModalTitle, { children: props.title }), subtitle: COBRANZA_REJECTED_POLICIES_SUBTITLE }, { children: [_jsx(PoliciesTableWrapper, { children: _jsx(AfyDataTable, __assign({}, TABLE_PROPS, { columns: COLUMNS, rows: props.rows, getRowId: function (row) { return String(row.id); }, page: modal.page, pageSize: modal.pageSize })) }), modal.showPagination && (_jsx(PaginationWrapper, { children: _jsx(AfyPagination, __assign({}, PAGINATION_PROPS, { totalItems: modal.totalItems, page: modal.page, pageSize: modal.pageSize, onPageChange: modal.onPageChange })) }))] })));
};
